module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/west_tigers.cd107ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/west_tigers.png
// module id = bGuz
// module chunks = 0